import { CircularProgress } from "@mui/material";
import React from "react";
export function GridLoadingSpinner() {
    return (React.createElement("div", { style: { display: "flex", justifyContent: "center", padding: "10px", position: "sticky", left: "50%", width: "100px" } },
        React.createElement(CircularProgress, { color: "inherit" })));
}
